import React from 'react';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import { N as Navigation } from '../../Navigation-yXC39IfA.js';
import { C as Content } from '../../Content-7EOS_2d5.js';
import 'react-i18next';
import 'notistack';
import '../../context/index.js';
import 'next/router';
import '../../Item-Z13RNFMm.js';
import 'next-i18next';
import '../Link/index.js';
import '../../index-2586sEvh.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import 'next/link';
import '../../paths-ZKN3m62_.js';
import '../../language-BHHwgtQp.js';
import 'react-dom/server';
import '../../ShippingChart-WhG8PR2C.js';
import '../../utils/price.js';
import 'number-currency-format';
import 'lodash/get';
import '../../utils/currency.js';
import '../../currency-_kacFJHO.js';
import '../../BedShippingChart-5Mamjyyj.js';

const Help = ({ pageContent, shippingData, bedShippingCountries, bedShippingValues, getLocalNavigationItems, }) => (React.createElement("div", { id: "help", className: "help-page" },
    React.createElement(Navigation, { getLocalNavigationItems: getLocalNavigationItems }),
    React.createElement(Content, { pageContent: pageContent, shippingData: shippingData, bedShippingCountries: bedShippingCountries, bedShippingValues: bedShippingValues })));
var Help$1 = withProviders(Help, { translation: true });

export { Help$1 as default };
//# sourceMappingURL=index.js.map
